// extracted by mini-css-extract-plugin
module.exports = {"loginTitle":"login_loginTitle__2I87J","more":"login_more__1_Guc","other":"login_other__10G5J","left":"login_left__jINfj","right":"login_right__zs5Ii"};